import { render, staticRenderFns } from "./Heat.vue?vue&type=template&id=2c01d428&"
import script from "./Heat.vue?vue&type=script&lang=js&"
export * from "./Heat.vue?vue&type=script&lang=js&"
import style0 from "./Heat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports